var map = {
	"./ICE/answer1.png": 616,
	"./ICE/answer2.png": 617,
	"./ICE/answer3.png": 618,
	"./ICE/arrowLeft.png": 621,
	"./ICE/arrowRight.png": 620,
	"./ICE/background.png": 619,
	"./ICE/crankshaft.png": 613,
	"./ICE/crankshaft1.png": 1851,
	"./ICE/fuel.png": 162,
	"./ICE/gas.png": 622,
	"./ICE/ignition.png": 623,
	"./ICE/indicator.png": 243,
	"./ICE/indicatorLine.png": 624,
	"./ICE/indicatorRpm.png": 625,
	"./ICE/kolba.png": 607,
	"./ICE/kolba2.png": 244,
	"./ICE/kolba3.png": 610,
	"./ICE/piston.png": 609,
	"./ICE/pistonBody.png": 612,
	"./ICE/pistonBody1.png": 1852,
	"./ICE/pistonHead.png": 611,
	"./ICE/sparkPlug.png": 161,
	"./ICE/spring.png": 608,
	"./ICE/stepsTable.png": 614,
	"./ICE/valve.png": 159,
	"./ICE/valveCam.png": 160,
	"./ICE/wasteGas.png": 615,
	"./IdealGas/background-Chart1.png": 1853,
	"./IdealGas/background-Chart2.png": 1854,
	"./IdealGas/background-Chart3.png": 1855,
	"./IdealGas/bg1-3.png": 589,
	"./IdealGas/bg_Isobar_isochore.png": 591,
	"./IdealGas/bg_adiabat.png": 592,
	"./IdealGas/bg_isotherm.png": 590,
	"./IdealGas/blue_ball.png": 210,
	"./IdealGas/blue_ballon.png": 1856,
	"./IdealGas/grey_ball.png": 1857,
	"./IdealGas/light_grey_ball.png": 1858,
	"./IdealGas/piston.png": 1859,
	"./IdealGas/piston_case - Copy.png": 1860,
	"./IdealGas/piston_case.png": 1861,
	"./IdealGas/red_ball.png": 158,
	"./IdealGas/red_ballon.png": 1862,
	"./IdealGas/white_ball.png": 1863,
	"./XY.png": 1864,
	"./add_task_to_homework.png": 994,
	"./allLifting/bowl.png": 267,
	"./allLifting/briks.png": 101,
	"./allLifting/cargo.png": 747,
	"./allLifting/concreteMixer.png": 266,
	"./allLifting/liftingMethod1.png": 1865,
	"./allLifting/liftingMethod2.png": 1866,
	"./allLifting/liftingMethod3.png": 1867,
	"./allLifting/liftingMethod4.png": 1868,
	"./allLifting/liftingMethod5.png": 1869,
	"./allLifting/liftingMethod6.png": 1870,
	"./allLifting/liftingMethod7.png": 1871,
	"./allLifting/liftingMethod8.png": 1872,
	"./allLifting/piano.png": 100,
	"./allLifting/star.png": 748,
	"./allLifting/star_opacity.png": 749,
	"./balloon/noAirBaloon.png": 606,
	"./balloon/noBaloon.png": 605,
	"./balloon/redBall.png": 603,
	"./balloon/redBall2.png": 604,
	"./balloon/redBall3.png": 1873,
	"./beaker/beaker1.png": 259,
	"./beaker/beaker2.png": 721,
	"./beaker/beaker3.png": 281,
	"./bondGas/Asset 47.png": 1874,
	"./bondGas/Chip.png": 750,
	"./bondGas/base.png": 751,
	"./bondGas/dark_green_ball.png": 752,
	"./bondGas/flask.png": 753,
	"./bondGas/flaskCold.png": 754,
	"./bondGas/flaskHot.png": 755,
	"./bondGas/gasBox.png": 756,
	"./bondGas/piton.png": 757,
	"./bondGas/rotateArrow.png": 333,
	"./bondGas/stick.png": 758,
	"./bondGas/tempBox.png": 759,
	"./bondGas/tempSlide.png": 760,
	"./bondGas/wheel.png": 1875,
	"./bondGas/wheelHandle.png": 1876,
	"./bondGas/wheelHandle2.png": 761,
	"./bondGas/wheelRect.png": 762,
	"./bondSubmarine/airBg.png": 763,
	"./bondSubmarine/breakSubmarine.png": 368,
	"./bondSubmarine/fish-1.png": 995,
	"./bondSubmarine/fish-10.png": 996,
	"./bondSubmarine/fish-11.png": 997,
	"./bondSubmarine/fish-12.png": 998,
	"./bondSubmarine/fish-13.png": 999,
	"./bondSubmarine/fish-14.png": 1000,
	"./bondSubmarine/fish-15.png": 1001,
	"./bondSubmarine/fish-16.png": 1002,
	"./bondSubmarine/fish-17.png": 1003,
	"./bondSubmarine/fish-18.png": 1004,
	"./bondSubmarine/fish-19.png": 1005,
	"./bondSubmarine/fish-2.png": 1006,
	"./bondSubmarine/fish-20.png": 1007,
	"./bondSubmarine/fish-21.png": 1008,
	"./bondSubmarine/fish-22.png": 1009,
	"./bondSubmarine/fish-23.png": 1010,
	"./bondSubmarine/fish-3.png": 1011,
	"./bondSubmarine/fish-4.png": 1012,
	"./bondSubmarine/fish-5.png": 1013,
	"./bondSubmarine/fish-6.png": 1014,
	"./bondSubmarine/fish-7.png": 1015,
	"./bondSubmarine/fish-8.png": 1016,
	"./bondSubmarine/fish-9.png": 1017,
	"./bondSubmarine/patter1.png": 764,
	"./bondSubmarine/pattern2.png": 765,
	"./bondSubmarine/submarine.png": 766,
	"./bondSubmarine/underwaterBase.png": 767,
	"./brakingDistances/1.png": 768,
	"./brakingDistances/2.png": 769,
	"./brakingDistances/3.png": 770,
	"./brakingDistances/auto.png": 771,
	"./brakingDistances/background.png": 772,
	"./brakingDistances/btnDown.png": 773,
	"./brakingDistances/btnUp.png": 774,
	"./brakingDistances/cargo.png": 775,
	"./brakingDistances/formulas.png": 776,
	"./brakingDistances/road.png": 777,
	"./brakingDistances/wheel.png": 778,
	"./brickFactory/background.png": 642,
	"./brickFactory/borderHorizontal.png": 644,
	"./brickFactory/borderVertical.png": 643,
	"./brickFactory/brick1.png": 645,
	"./brickFactory/brick2.png": 646,
	"./brickFactory/controll3.png": 649,
	"./brickFactory/dispenser.png": 648,
	"./brickFactory/kiln.png": 647,
	"./brickFactory/line 2.png": 1877,
	"./brickFactory/line.png": 1878,
	"./brownianMotion/blueGasCylinder.png": 594,
	"./brownianMotion/fire.png": 1879,
	"./brownianMotion/ground.png": 599,
	"./brownianMotion/indicator.png": 596,
	"./brownianMotion/pistion.png": 597,
	"./brownianMotion/pistonCase.png": 595,
	"./brownianMotion/redGasCylinder.png": 593,
	"./brownianMotion/scene.png": 331,
	"./brownianMotion/tube.png": 598,
	"./bus/bus.png": 779,
	"./bus/busBg.png": 780,
	"./bus/darkBus.png": 781,
	"./bus/dialogGreen.png": 369,
	"./bus/dialogRed.png": 370,
	"./bus/gas.png": 782,
	"./bus/house1.png": 1018,
	"./bus/house10.png": 1019,
	"./bus/house11.png": 1020,
	"./bus/house12.png": 1021,
	"./bus/house13.png": 1022,
	"./bus/house2.png": 1023,
	"./bus/house3.png": 1024,
	"./bus/house4.png": 1025,
	"./bus/house5.png": 1026,
	"./bus/house6.png": 1027,
	"./bus/house7.png": 1028,
	"./bus/house8.png": 1029,
	"./bus/house9.png": 1030,
	"./bus/human1.png": 783,
	"./bus/human2.png": 784,
	"./bus/human3.png": 785,
	"./bus/human4.png": 786,
	"./bus/human5.png": 787,
	"./bus/human6.png": 788,
	"./bus/human7.png": 789,
	"./bus/human8.png": 790,
	"./bus/human9.png": 791,
	"./bus/indicator.png": 792,
	"./bus/indicatorLine.png": 793,
	"./bus/lawn.png": 1880,
	"./bus/light.png": 794,
	"./bus/road.png": 1881,
	"./bus/sidewalk.png": 1882,
	"./bus/sky.png": 795,
	"./bus/stop.png": 796,
	"./bus/stopLight.png": 797,
	"./bus/sun.png": 798,
	"./bus/tree.png": 799,
	"./bus/tree2.png": 800,
	"./bus/tunnel.png": 801,
	"./bus/wheel.png": 802,
	"./bus/windowLight.png": 803,
	"./bus/окна - под автобусом но над людьми.png": 1883,
	"./bus/поверх домов.png": 1884,
	"./chemistry/liquid.png": 694,
	"./chemistry/pointer.png": 695,
	"./chemistry/scene.png": 693,
	"./cityLighting/2Asset 8.png": 1885,
	"./cityLighting/Asset 4.png": 1886,
	"./cityLighting/Mountain.png": 632,
	"./cityLighting/backgroundDay.png": 634,
	"./cityLighting/backgroundNight.png": 633,
	"./cityLighting/buildings.png": 635,
	"./cityLighting/buildingsLight.png": 636,
	"./cityLighting/powerCable1.png": 640,
	"./cityLighting/powerCable2.png": 641,
	"./cityLighting/station.png": 638,
	"./cityLighting/transformer.png": 637,
	"./cityLighting/water.png": 639,
	"./crane/background.png": 163,
	"./crane/bigWheel.png": 658,
	"./crane/box.png": 165,
	"./crane/boxes.png": 166,
	"./crane/boxesCrane6.png": 167,
	"./crane/boxesCrane7.png": 245,
	"./crane/crane.png": 168,
	"./crane/cross.png": 246,
	"./crane/engine.png": 169,
	"./crane/hook.png": 170,
	"./crane/info.png": 247,
	"./crane/switchBtn.png": 532,
	"./crane/switchTrackGreen.png": 533,
	"./crane/switchTrackPurple.png": 534,
	"./crane/wheel.png": 164,
	"./crane/withScenario/controller.png": 657,
	"./crown/background1.png": 539,
	"./crown/background2.png": 540,
	"./crown/background3.png": 541,
	"./crown/crown.png": 235,
	"./crown/crownScale/Asset 66.png": 1887,
	"./crown/crownScale/Asset 71.png": 1888,
	"./crown/crownScale/weight100.png": 360,
	"./crown/crownScale/weight1000.png": 361,
	"./crown/crownScale/weight20.png": 359,
	"./crown/dinamometr.png": 542,
	"./crown/hook.png": 543,
	"./curvedArrow.png": 746,
	"./dynamometer/box.png": 651,
	"./dynamometer/dynamometer.png": 652,
	"./dynamometer/dynamometerEn.png": 653,
	"./dynamometer/ground.png": 654,
	"./dynamometer/hook.png": 655,
	"./dynamometer/pointer.png": 650,
	"./dynamometer/smallHook.png": 656,
	"./efficiency/oilBottle.png": 314,
	"./electrostatic/ball.png": 677,
	"./electrostatic/electroscope.png": 251,
	"./electrostatic/electroscopeBall.png": 682,
	"./electrostatic/minus.png": 183,
	"./electrostatic/negative_wire.png": 680,
	"./electrostatic/neutral_wire.png": 681,
	"./electrostatic/plus.png": 182,
	"./electrostatic/positive_wire.png": 679,
	"./electrostatic/silverball.png": 678,
	"./electrostatic/stick.png": 683,
	"./endBtn.png": 967,
	"./failIcon.png": 156,
	"./fountain/Asset 1.png": 1889,
	"./fountain/Asset 2.png": 1890,
	"./fountain/Asset 6.png": 1891,
	"./fountain/Asset 7.png": 1892,
	"./fountain/Asset 8.png": 1893,
	"./fountain/empty_scene.png": 672,
	"./fountain/start_scene.png": 671,
	"./fountain/start_scene1.png": 1894,
	"./fountain/tower.png": 673,
	"./gearRatios/Asset 10.png": 1895,
	"./gearRatios/Asset 12.png": 1896,
	"./gearRatios/Asset 13.png": 1897,
	"./gearRatios/Asset 4.png": 1898,
	"./gearRatios/Asset 5.png": 1899,
	"./gearRatios/Asset 6.png": 1900,
	"./gearRatios/Asset 7.png": 1901,
	"./gearRatios/arrowGrey.png": 485,
	"./gearRatios/block.png": 496,
	"./gearRatios/bridge.png": 467,
	"./gearRatios/castle.png": 472,
	"./gearRatios/gates.png": 471,
	"./gearRatios/gearEngine1.png": 357,
	"./gearRatios/gearEngine2.png": 358,
	"./gearRatios/gearEngine3.png": 497,
	"./gearRatios/gearHigh.png": 477,
	"./gearRatios/gearSmall.png": 476,
	"./gearRatios/handle.png": 475,
	"./gearRatios/marathon.png": 488,
	"./gearRatios/person.png": 466,
	"./gearRatios/pirateShip.png": 465,
	"./gearRatios/river-background.png": 468,
	"./gearRatios/scaleStick.png": 231,
	"./gearRatios/scaleStick2.png": 232,
	"./gearRatios/scene.png": 1902,
	"./gearRatios/sheave.png": 229,
	"./gearRatios/sheaveGray.png": 470,
	"./gearRatios/statusBar1.png": 489,
	"./gearRatios/statusBar11.png": 490,
	"./gearRatios/statusBar2.png": 491,
	"./gearRatios/statusBar22.png": 492,
	"./gearRatios/statusBar3.png": 493,
	"./gearRatios/statusBar33.png": 494,
	"./gearRatios/textWeight.png": 487,
	"./gearRatios/tower.png": 474,
	"./gearRatios/triangle.png": 486,
	"./gearRatios/triangle2.png": 233,
	"./gearRatios/wall.png": 473,
	"./gearRatios/weight.png": 479,
	"./gearRatios/weight1.png": 481,
	"./gearRatios/weight2.png": 495,
	"./gearRatios/weight3.png": 482,
	"./gearRatios/weight5.png": 480,
	"./gearRatios/weightGruz.png": 484,
	"./gearRatios/weightQ.png": 483,
	"./grayCross.png": 89,
	"./grid.png": 1903,
	"./ground.png": 720,
	"./hintArrow.png": 230,
	"./hydraulicPress/1Asset 3.png": 1904,
	"./hydraulicPress/1Asset 4.png": 1905,
	"./hydraulicPress/1Asset 6.png": 1906,
	"./hydraulicPress/1Asset 7.png": 1907,
	"./hydraulicPress/1Asset 8.png": 1908,
	"./hydraulicPress/Asset 3.png": 1909,
	"./hydraulicPress/Asset 4.png": 1910,
	"./hydraulicPress/Asset 5.png": 1911,
	"./hydraulicPress/bar.png": 663,
	"./hydraulicPress/big_case.png": 659,
	"./hydraulicPress/big_piston.png": 666,
	"./hydraulicPress/case.png": 1912,
	"./hydraulicPress/cylinder.png": 667,
	"./hydraulicPress/fake_bar.png": 664,
	"./hydraulicPress/large_cylinder.png": 670,
	"./hydraulicPress/left_case.png": 660,
	"./hydraulicPress/pointer.png": 669,
	"./hydraulicPress/right_case.png": 661,
	"./hydraulicPress/small_piston.png": 665,
	"./hydraulicPress/stand.png": 662,
	"./hydraulicPress/top_bar.png": 668,
	"./hydraulicPress/Гидравлический пресс.png": 1913,
	"./ilustrations/illustration_block.png": 804,
	"./ilustrations/illustration_vorot.png": 805,
	"./island.png": 1914,
	"./islandWithPier.png": 1915,
	"./kineticEnergy/auto.png": 806,
	"./kineticEnergy/background.png": 807,
	"./kineticEnergy/btnDown.png": 808,
	"./kineticEnergy/btnUp.png": 809,
	"./kineticEnergy/cargo.png": 810,
	"./kineticEnergy/formulaKineticEnergy.png": 811,
	"./kineticEnergy/formulaMass.png": 812,
	"./kineticEnergy/formulaSpeed.png": 813,
	"./kineticEnergy/road.png": 814,
	"./kineticEnergy/wheel.png": 815,
	"./liftingBlocksMultiple/liftingMethod1.png": 1916,
	"./liftingBlocksMultiple/liftingMethod2.png": 1917,
	"./liftingBlocksMultiple/liftingMethod3.png": 1918,
	"./liftingInclinedSurface/liftingMethod1.png": 1919,
	"./liftingInclinedSurface/liftingMethod2.png": 1920,
	"./liftingLoadMultiple/Asset 34.png": 1921,
	"./liftingLoadMultiple/Asset 36.png": 1922,
	"./liftingLoadMultiple/Asset 37.png": 1923,
	"./liftingLoadMultiple/Asset 38.png": 1924,
	"./liftingLoadMultiple/Asset 40.png": 1925,
	"./liftingLoadMultiple/Asset 43.png": 1926,
	"./liftingLoadMultiple/Asset 64.png": 1927,
	"./liftingLoadMultiple/Asset 68.png": 1928,
	"./liftingLoadMultiple/background.png": 260,
	"./liftingLoadMultiple/cargo.png": 201,
	"./liftingLoadMultiple/cargo2.png": 1929,
	"./liftingLoadMultiple/hook.png": 1930,
	"./liftingLoadMultiple/liftingMethod1.png": 1931,
	"./liftingLoadMultiple/liftingMethod2.png": 1932,
	"./liftingLoadMultiple/liftingMethod3.png": 1933,
	"./liftingLoadMultiple/liftingMethod4.png": 1934,
	"./liftingLoadMultiple/springboard.png": 265,
	"./liftingLoadMultiple/supportStand.png": 264,
	"./liftingLoadMultiple/triangleGray.png": 262,
	"./liftingLoadMultiple/wheel.png": 261,
	"./liftingLoadMultiple/windingArrow.png": 263,
	"./loop/background.png": 628,
	"./loop/car.png": 631,
	"./loop/jeep.png": 630,
	"./loop/wheel.png": 629,
	"./lvlComplete.png": 816,
	"./momentRules/weight1.png": 1031,
	"./momentRules/weight2.png": 1032,
	"./momentRules/weight3.png": 1033,
	"./momentRules/weight4.png": 1034,
	"./momentRules/weight5.png": 1035,
	"./mountains/air.png": 817,
	"./mountains/bgLab.png": 818,
	"./mountains/lab.png": 819,
	"./mountains/mountains.png": 820,
	"./mountains/table.png": 821,
	"./movableFixedBLock/Asset 14.png": 1935,
	"./movableFixedBLock/Asset 15.png": 1936,
	"./movableFixedBLock/Asset 16.png": 1937,
	"./movableFixedBLock/Asset 7.png": 1938,
	"./movableFixedBLock/F1.png": 822,
	"./movableFixedBLock/F2.png": 823,
	"./movableFixedBLock/formula1.png": 371,
	"./movableFixedBLock/formula2.png": 372,
	"./movableFixedBLock/l1.png": 824,
	"./movableFixedBLock/l2.png": 825,
	"./movableFixedBLock/movableBlock.png": 826,
	"./movableFixedBLock/topBlock.png": 827,
	"./movableFixedBLock/weight5.png": 828,
	"./oscillation/background.png": 626,
	"./pathandspeed/biker1.png": 252,
	"./pathandspeed/biker2.png": 697,
	"./pathandspeed/cars/background.png": 715,
	"./pathandspeed/cars/blueMark.png": 990,
	"./pathandspeed/cars/carBlue.png": 714,
	"./pathandspeed/cars/carGreen.png": 713,
	"./pathandspeed/cars/carRed.png": 712,
	"./pathandspeed/cars/chartPathBig.png": 710,
	"./pathandspeed/cars/chartPathSmall.png": 1939,
	"./pathandspeed/cars/chartSpeedBig.png": 711,
	"./pathandspeed/cars/chartSpeedSmall.png": 1940,
	"./pathandspeed/cars/greenMark.png": 991,
	"./pathandspeed/cars/redMark.png": 992,
	"./pathandspeed/chart.png": 696,
	"./pathandspeed/complete.png": 171,
	"./pathandspeed/mainCharForError1.png": 702,
	"./pathandspeed/mainCharForError2.png": 703,
	"./pathandspeed/mainCharStairway.png": 367,
	"./pathandspeed/mainChart.png": 698,
	"./pathandspeed/mainChartDescr1.png": 704,
	"./pathandspeed/mainChartDescr2.png": 705,
	"./pathandspeed/pathAndSpeed6/mainChart1.png": 84,
	"./pathandspeed/pathAndSpeed6/mainChart1ForError1.png": 706,
	"./pathandspeed/pathAndSpeed6/mainChart1ForError2.png": 707,
	"./pathandspeed/pathAndSpeed6/mainChart1ForError3.png": 708,
	"./pathandspeed/pathAndSpeed6/mainChart1ForError4.png": 709,
	"./pathandspeed/pathAndSpeed6/mainChart2.png": 278,
	"./pathandspeed/pathAndSpeed6/mainChart2Descr1.png": 279,
	"./pathandspeed/pathAndSpeed6/mainChart2Descr2.png": 280,
	"./pathandspeed/rightChart.png": 699,
	"./pathandspeed/road.png": 332,
	"./pathandspeed/space/Asset 8.png": 1941,
	"./pathandspeed/space/Asset 9.png": 1942,
	"./pathandspeed/space/background.png": 257,
	"./pathandspeed/space/chart1.png": 184,
	"./pathandspeed/space/chart1ForPoints.png": 186,
	"./pathandspeed/space/chart2.png": 185,
	"./pathandspeed/space/chart2ForPoints.png": 187,
	"./pathandspeed/space/craters.png": 701,
	"./pathandspeed/space/engin.png": 258,
	"./pathandspeed/space/exclamationIcon.png": 718,
	"./pathandspeed/space/ship.png": 719,
	"./pathandspeed/space/ship2.png": 253,
	"./pathandspeed/successArrow.png": 700,
	"./pathandspeed/train/arrowGrey.png": 256,
	"./pathandspeed/train/background.png": 254,
	"./pathandspeed/train/background2.png": 716,
	"./pathandspeed/train/timer.png": 172,
	"./pathandspeed/train/timer2.png": 1943,
	"./pathandspeed/train/timerEn.png": 717,
	"./pathandspeed/train/train.png": 173,
	"./pathandspeed/train/train2.png": 174,
	"./pathandspeed/train/trainSpeed.png": 255,
	"./peryshkinDam/aeroplane.png": 829,
	"./peryshkinDam/background.png": 830,
	"./peryshkinDam/backgroundHelper.png": 831,
	"./peryshkinDam/mechanism.png": 832,
	"./peryshkinDam/wheelContainer.png": 833,
	"./pier.png": 1944,
	"./play.png": 834,
	"./popupImage.png": 1945,
	"./positiveNegativeWork/background.png": 739,
	"./positiveNegativeWork/bolid.png": 742,
	"./positiveNegativeWork/ground.png": 740,
	"./positiveNegativeWork/indicator.png": 741,
	"./power1W/background.png": 732,
	"./power1W/car.png": 736,
	"./power1W/controller.png": 734,
	"./power1W/formula.png": 733,
	"./power1W/hookStart.png": 738,
	"./power1W/timer.png": 737,
	"./power1W/wheel.png": 735,
	"./powerExample/electricalAppliances.png": 835,
	"./powerExample/motors.png": 836,
	"./rally/background.png": 600,
	"./rally/car.png": 602,
	"./rally/monitor.png": 1946,
	"./rally/plane.png": 601,
	"./redcorss.png": 837,
	"./relativeMotion/chema/bg.png": 373,
	"./relativeMotion/chema/meteor.png": 374,
	"./relativeMotion/chema/planet.png": 375,
	"./relativeMotion/chema/rocket.png": 376,
	"./relativeMotion/chema/spaceShip.png": 377,
	"./relativeMotion/task/asteroid.png": 838,
	"./relativeMotion/task/bg.png": 839,
	"./relativeMotion/task/plant.png": 840,
	"./relativeMotion/task/rocket.png": 841,
	"./relativeMotion/task/ship.png": 842,
	"./scaleForCubes/aluminum.png": 228,
	"./scaleForCubes/brick.png": 316,
	"./scaleForCubes/cork.png": 317,
	"./scaleForCubes/differentVolume/brick.png": 515,
	"./scaleForCubes/differentVolume/gold.png": 516,
	"./scaleForCubes/differentVolume/oak.png": 517,
	"./scaleForCubes/differentVolume/silver.png": 518,
	"./scaleForCubes/gold.png": 318,
	"./scaleForCubes/ice.png": 319,
	"./scaleForCubes/oak.png": 320,
	"./scaleForCubes/silver.png": 321,
	"./scaleForCubes/steel.png": 322,
	"./scales/base.png": 512,
	"./scales/lever.png": 513,
	"./scales/platform.png": 514,
	"./scales/weight10.png": 507,
	"./scales/weight100.png": 510,
	"./scales/weight20.png": 508,
	"./scales/weight5.png": 506,
	"./scales/weight50.png": 509,
	"./scales/weightQ1.png": 315,
	"./scales/weightQ2.png": 234,
	"./skiBond/background2.png": 843,
	"./snowboard/background.png": 844,
	"./snowboard/indicator.png": 845,
	"./snowboard/mainInfoFormula.png": 846,
	"./snowboard/man.png": 847,
	"./snowboard/speedFormula.png": 848,
	"./snowboard/track.png": 849,
	"./snowboard/trackL.png": 378,
	"./snowboard/trackR.png": 850,
	"./snowboard/tree.png": 851,
	"./socialArrow.png": 852,
	"./space.png": 627,
	"./space/answerWindow.png": 1947,
	"./space/exclamationIcon.png": 1948,
	"./space/jumping_on_planets/background.png": 571,
	"./space/jumping_on_planets/planet1.png": 572,
	"./space/jumping_on_planets/planet2.png": 573,
	"./space/jumping_on_planets/planet3.png": 574,
	"./space/jumping_on_planets/planet4.png": 575,
	"./space/jumping_on_planets/planet5.png": 576,
	"./space/loss_satellite/Asset 150.png": 1949,
	"./space/loss_satellite/Asset 151.png": 1950,
	"./space/loss_satellite/background.png": 577,
	"./space/path_and_speed/Asset 34.png": 1951,
	"./space/path_and_speed/Asset 35.png": 1952,
	"./space/path_and_speed/Asset 36.png": 1953,
	"./space/path_and_speed/Asset 38.png": 1954,
	"./space/path_and_speed/Asset 40.png": 1955,
	"./space/repulsion_of_bodies/astronautArm.png": 581,
	"./space/repulsion_of_bodies/astronautBody.png": 580,
	"./space/repulsion_of_bodies/dashCircle.png": 1956,
	"./space/repulsion_of_bodies/fatMan.png": 584,
	"./space/repulsion_of_bodies/shadowAstronaut1.png": 241,
	"./space/repulsion_of_bodies/shadowAstronaut2.png": 583,
	"./space/repulsion_of_bodies/shadowSpaceship.png": 579,
	"./space/repulsion_of_bodies/strongMan.png": 585,
	"./space/repulsion_of_bodies/wholeAstronaut.png": 582,
	"./space/spaceBackground.png": 239,
	"./space/spaceBackground2.png": 240,
	"./space/spaceship.png": 578,
	"./space/spaceship_asteroid_1/Asset 33.png": 1957,
	"./space/spaceship_asteroid_1/Asset 34.png": 1958,
	"./space/spaceship_asteroid_1/asteroid.png": 330,
	"./space/spaceship_asteroid_1/btnDown.png": 328,
	"./space/spaceship_asteroid_1/btnTop.png": 327,
	"./space/spaceship_asteroid_1/engine.png": 238,
	"./space/spaceship_asteroid_1/planeta1.png": 564,
	"./space/spaceship_asteroid_1/planeta2.png": 565,
	"./space/spaceship_asteroid_1/planeta3.png": 566,
	"./space/spaceship_asteroid_1/planeta4.png": 971,
	"./space/spaceship_asteroid_1/planeta5.png": 972,
	"./space/spaceship_asteroid_1/planeta6.png": 973,
	"./space/spaceship_asteroid_1/planeta7.png": 974,
	"./space/spaceship_asteroid_1/pointItem.png": 329,
	"./space/spaceship_asteroid_1/spaceship.png": 563,
	"./space/spaceship_asteroid_2/dialog.png": 570,
	"./space/spaceship_asteroid_2/dude.png": 569,
	"./space/spaceship_asteroid_2/planet1.png": 1959,
	"./space/spaceship_asteroid_2/pointItemImg.png": 1960,
	"./space/spaceship_asteroid_2/spaceship.png": 363,
	"./space/spaceship_asteroid_2/stantionBig.png": 567,
	"./space/spaceship_asteroid_2/stantionSMall.png": 568,
	"./space/spaceship_landing/Asset 137.png": 1961,
	"./space/spaceship_landing/Asset 63.png": 1962,
	"./space/spaceship_landing/Asset 64.png": 1963,
	"./space/spaceship_landing/Asset 71.png": 1964,
	"./space/spaceship_landing/Asset 72.png": 1965,
	"./space/spaceship_landing/btn-left.png": 137,
	"./space/spaceship_landing/btn-right.png": 138,
	"./space/spaceship_landing/btn-top.png": 157,
	"./space/spaceship_landing/cyberpunk-btn.png": 552,
	"./space/spaceship_landing/cyberpunk-form.png": 551,
	"./space/spaceship_landing/engine-fire.png": 545,
	"./space/spaceship_landing/landing-place.png": 546,
	"./space/spaceship_landing/living-module.png": 547,
	"./space/spaceship_landing/ship-inside.png": 1966,
	"./space/spaceship_landing/spaceship.png": 325,
	"./space/spaceship_landing/stantion-1.png": 548,
	"./space/spaceship_landing/stantion-2.png": 549,
	"./space/spaceship_landing/Элементы ветра/shape-1.png": 1967,
	"./space/spaceship_landing/Элементы ветра/shape-2.png": 1968,
	"./space/spaceship_landing/Элементы ветра/shape-3.png": 1969,
	"./space/spaceship_landing/Элементы ветра/shape-4.png": 1970,
	"./space/spaceship_landing/Элементы ветра/shape-5.png": 1971,
	"./space/spaceship_landing/Элементы ветра/shape-6.png": 1972,
	"./space/spaceship_landing/Элементы ветра/shape-7.png": 1973,
	"./space/spaceship_landing/Элементы ветра/shape-8.png": 1974,
	"./space/spaceship_landing/Элементы ветра/shape-9.png": 1975,
	"./space/spaceship_take_off/Asset 146.png": 1976,
	"./space/spaceship_take_off/answerWindow.png": 237,
	"./space/spaceship_take_off/btnFuel.png": 560,
	"./space/spaceship_take_off/btnLeft.png": 561,
	"./space/spaceship_take_off/btnRight.png": 562,
	"./space/spaceship_take_off/btnStart.png": 559,
	"./space/spaceship_take_off/fuelIndicatorBorder.png": 558,
	"./space/spaceship_take_off/launchFacility.png": 554,
	"./space/spaceship_take_off/launchGround.png": 555,
	"./space/spaceship_take_off/launchServiceFarm.png": 556,
	"./space/spaceship_take_off/spaceship.png": 553,
	"./space/spaceship_take_off/spshipTraectory.png": 557,
	"./space/spaceship_take_off/traectoryLine.png": 1977,
	"./space/spaceship_take_off/traectoryLine2.png": 1978,
	"./space/theory/Asset 86.png": 464,
	"./space/theory/background.png": 199,
	"./space/theory/dialogArrow.png": 326,
	"./space/theory/theoryQ1.png": 550,
	"./star.png": 853,
	"./startBtn.png": 966,
	"./steamEngine/cork.png": 588,
	"./steamEngine/flask1-background.png": 586,
	"./steamEngine/flask2-background.png": 587,
	"./steamEngine/piston-task-2.png": 242,
	"./steamEngine/piston.png": 499,
	"./steamEngine/steam_box.png": 503,
	"./steamEngine/steam_tube_1.png": 504,
	"./steamEngine/steam_tube_2.png": 505,
	"./steamEngine/stick.png": 500,
	"./steamEngine/switch.png": 502,
	"./steamEngine/water_box.png": 501,
	"./steamEngine/wheel.png": 498,
	"./submarine/FarchAsset.png": 524,
	"./submarine/FtyazhAsset.png": 525,
	"./submarine/GameAsset 17.png": 1979,
	"./submarine/GameAsset 18.png": 1980,
	"./submarine/PodlozhkaAsset.png": 1981,
	"./submarine/againButton3.png": 523,
	"./submarine/boat1.png": 519,
	"./submarine/boat2.png": 520,
	"./submarine/boundaries.png": 522,
	"./submarine/boundariesBig.png": 531,
	"./submarine/checkButton.png": 526,
	"./submarine/data.png": 521,
	"./submarine/step2/background.png": 1982,
	"./submarine/step2/background2.png": 537,
	"./submarine/step2/boat-form.png": 535,
	"./submarine/step2/experiment 1-1.png": 1983,
	"./submarine/step2/experiment 1-2.png": 1984,
	"./submarine/step2/submarine.png": 536,
	"./submarine/step2/tube-2.png": 538,
	"./submarine/step2/tube.png": 1985,
	"./submarine/step2/Вода для заливки формы.png": 1986,
	"./submarine/step2/прозрачная вода для колбы.png": 1987,
	"./submarine/step4/background.png": 1988,
	"./submarine/step4/example.png": 1989,
	"./submarine/step4/platform.png": 530,
	"./submarine/step4/stick.png": 529,
	"./submarine/step4/submarineWater.png": 1990,
	"./submarine/step4/submarineWaterBig.png": 1991,
	"./submarine/step4/submarineWaterBig2.png": 528,
	"./submarine/step4/triangle.png": 323,
	"./submarine/submarineRealBig.png": 527,
	"./success.png": 854,
	"./successArrow.png": 1992,
	"./successArrow2.png": 511,
	"./tgCircle/925-521Asset 15.png": 1993,
	"./tgCircle/936-521Asset 13.png": 1994,
	"./tgCircle/arrow.png": 1995,
	"./tgCircle/arrow_orange.png": 692,
	"./tgCircle/correct.png": 689,
	"./tgCircle/crcl.png": 688,
	"./tgCircle/dragcircl.png": 690,
	"./tgCircle/dragcirclOrange.png": 691,
	"./tgCircle/formulas.png": 1996,
	"./tgCircle/o.png": 686,
	"./tgCircle/one.png": 687,
	"./tgCircle/x.png": 685,
	"./tgCircle/y.png": 684,
	"./timeDependenceOfWork/Asset 4.png": 1997,
	"./timeDependenceOfWork/Asset 5.png": 1998,
	"./timeDependenceOfWork/background.png": 743,
	"./timeDependenceOfWork/cargo.png": 745,
	"./timeDependenceOfWork/hook.png": 744,
	"./timeDependenceOfWork/next.png": 1999,
	"./timeDependenceOfWork/play.png": 2000,
	"./timeDependenceOfWork/prev.png": 2001,
	"./timeDependenceOfWork/stop.png": 2002,
	"./toricelliExperiment/--.png": 2003,
	"./toricelliExperiment/1Asset 10.png": 2004,
	"./toricelliExperiment/backgroundGround.png": 674,
	"./toricelliExperiment/backgroundMountains.png": 675,
	"./toricelliExperiment/column.png": 248,
	"./toricelliExperiment/cork.png": 250,
	"./toricelliExperiment/scale.png": 676,
	"./toricelliExperiment/stand.png": 249,
	"./toricelliExperiment/Шаг 1.png": 2005,
	"./toricelliExperiment/Шаг 2.png": 2006,
	"./toricelliExperiment/Шаг 3.png": 2007,
	"./toricelliExperiment/Шаг 4.png": 2008,
	"./waterTower/buildings.png": 855,
	"./waterTower/card.png": 856,
	"./waterTower/ground.png": 857,
	"./waterTower/tubeBorder.png": 858,
	"./waterTower/waterTank.png": 859,
	"./waterTower/waterTowerBase.png": 860,
	"./wave.png": 236,
	"./whiteHintArrow.png": 478,
	"./whitelabel/eShaala_logo.png": 861,
	"./work1J/arrowDown.png": 723,
	"./work1J/arrowRight.png": 724,
	"./work1J/arrowSuccess.png": 725,
	"./work1J/arrowWidth.png": 726,
	"./work1J/background.png": 722,
	"./work1J/books.png": 727,
	"./work1J/cup.png": 728,
	"./work1J/formula.png": 729,
	"./work1J/tiazh.png": 731,
	"./work1J/trenie.png": 730
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 993;